import type { Beer } from '../api/types';
import { BeerStatusBadge } from './BeerStatusBadge';
import '../styles/beers.css';

interface BeerTableProps {
  beers: Beer[];
  onBeerClick: (beer: Beer) => void;
}

function StyleBadge({ style }: { style: string }) {
  return (
    <span className="beers-style-badge">
      {style}
    </span>
  );
}

function BeerTableRow({ beer, onClick }: { beer: Beer; onClick: () => void }) {
  const visibleTags = beer.tags.slice(0, 3);
  const overflow = beer.tags.length - 3;

  return (
    <tr onClick={onClick} className="beers-table-row">
      <td className="beers-table-cell beers-table-name">{beer.name}</td>
      <td className="beers-table-cell"><StyleBadge style={beer.style} /></td>
      <td className="beers-table-cell beers-table-abv mono">
        {beer.abv != null ? `${beer.abv}%` : '—'}
      </td>
      <td className="beers-table-cell"><BeerStatusBadge status={beer.status} /></td>
      <td className="beers-table-cell">
        {beer.tags.length === 0
          ? <span className="beers-table-empty">—</span>
          : (
            <div className="beers-table-tag-row">
              {visibleTags.map(t => (
                <span key={t} className="beers-table-tag">{t}</span>
              ))}
              {overflow > 0 && (
                <span className="beers-table-overflow">+{overflow} more</span>
              )}
            </div>
          )
        }
      </td>
    </tr>
  );
}

export function BeerTable({ beers, onBeerClick }: BeerTableProps) {
  return (
    <table className="beers-table">
      <thead>
        <tr>
          <th className="beers-table-head">Name</th>
          <th className="beers-table-head">Style</th>
          <th className="beers-table-head">ABV</th>
          <th className="beers-table-head">Status</th>
          <th className="beers-table-head">Tags</th>
        </tr>
      </thead>
      <tbody>
        {beers.map(beer => (
          <BeerTableRow key={beer.id} beer={beer} onClick={() => onBeerClick(beer)} />
        ))}
      </tbody>
    </table>
  );
}
